import t from '@zenlayer/zen-intl18';
export var CHARGE_TYPE;
/**
 * 预付费（付费模式）/后付费（按量付费）统一文案
 * @constant
 * @example
 * getConstant().CONSTANT_ENUM.PRICING[variable_pricing]?.lable
 * Object.values(getConstant().CONSTANT_ENUM.PRICING).map(...)
 */

(function (CHARGE_TYPE) {
  CHARGE_TYPE["POSTPAID"] = "POSTPAID";
  CHARGE_TYPE["PAY_AS_YOU_GO_BY_HOUR"] = "PAY_AS_YOU_GO_BY_HOUR";
  CHARGE_TYPE["PAY_AS_YOU_GO_BY_MONTH"] = "PAY_AS_YOU_GO_BY_MONTH";
  CHARGE_TYPE["PAY_AS_YOU_GO_BY_DAY"] = "PAY_AS_YOU_GO_BY_DAY";
  CHARGE_TYPE["PREPAID"] = "PREPAID";
  CHARGE_TYPE["OFFLINE"] = "OFFLINE";
})(CHARGE_TYPE || (CHARGE_TYPE = {}));

export function getConstant() {
  var CONSTANT_ENUM = {
    PRICING: {
      POSTPAID: {
        value: CHARGE_TYPE.POSTPAID,
        label: t('KO688D0Exx1Q')
      },
      PREPAID: {
        value: CHARGE_TYPE.PREPAID,
        label: t('Y4FRMnrhgT9C')
      },
      PAY_AS_YOU_GO_BY_HOUR: {
        value: CHARGE_TYPE.PAY_AS_YOU_GO_BY_HOUR,
        label: t('O31dIozHQKiO')
      },
      PAY_AS_YOU_GO_BY_MONTH: {
        value: CHARGE_TYPE.PAY_AS_YOU_GO_BY_MONTH,
        label: t('2pqvw6verY2h')
      },
      PAY_AS_YOU_GO_BY_DAY: {
        value: CHARGE_TYPE.PAY_AS_YOU_GO_BY_DAY,
        label: t('WT3YSfITgGhq')
      },
      OFFLINE: {
        value: CHARGE_TYPE.OFFLINE,
        label: t('DdbQcrZnHWAt')
      }
    }
  };
  return CONSTANT_ENUM;
}
export var isPostpaidChargeType = function isPostpaidChargeType(chargeType) {
  var postpaidList = [CHARGE_TYPE.PAY_AS_YOU_GO_BY_DAY, CHARGE_TYPE.PAY_AS_YOU_GO_BY_HOUR, CHARGE_TYPE.PAY_AS_YOU_GO_BY_MONTH, CHARGE_TYPE.POSTPAID];
  return !!chargeType && postpaidList.includes(chargeType);
};
export var isPrepaidChargeType = function isPrepaidChargeType(chargeType) {
  return chargeType === CHARGE_TYPE.PREPAID;
};
export var isOfflineChargeType = function isOfflineChargeType(chargeType) {
  return chargeType === CHARGE_TYPE.OFFLINE;
};